import $ from 'jquery';

var contactInfoOwner = 
{
    initContactInfoOwner: function()
    {
        // Listen to click event on the submit button
        $('#submitFormBuyerOwner').click(function (e) 
        {
            e.preventDefault();

            window.showPreLoader();
            $("#failMsg").addClass("hide");
            $("#successMsg").addClass("hide");
          
            // If the user is an owner, these fields do not exist
            if($('#coOwnerFirstName').length > 0 && $('#coOwnerLastName').length > 0)
            {
                triggerFieldValidation('#coOwnerFirstName','#coOwnerFirstNameErrorMsg');
                triggerFieldValidation('#coOwnerLastName','#coOwnerLastNameErrorMsg');
            }

            if($(".is-invalid-input").length == 0)
            {
                var obj = new Object();

                obj.FirstName = $('#ownerFirstName').val();
                obj.LastName = $('#ownerLastName').val();
                obj.Address1 = $('#ownerAddress').val();
                obj.City = $('#ownerCity').val();
                obj.State = $('#ownerState').val();
                obj.PostalCode = $('#ownerZip').val();

                // Phone validation
                obj.HomePhone = $('#home-phone').val();
                obj.MobilePhone = $('#mobile-phone').val();
                obj.WorkPhone = $('#work-phone').val();
                obj.RecieveTextMsg = $('#cbxIsReceiveSMS').is(':checked');
                
                var IsPhoneAndCheckboxValid = ((obj.RecieveTextMsg && obj.MobilePhone !== "") || !obj.RecieveTextMsg);
                if(!IsPhoneAndCheckboxValid)
                {
                    $("#mobilePhoneErrorMsg").show();
                }else{$("#mobilePhoneErrorMsg").hide();}


                // GA tags
                obj.ClientId = $('#gaclientid_il').val();
                obj.UserId = $('#gauserid_il').val();
                obj.TrackId = $('#gatrackid_il').val();
                obj.LastWebCampaign = $('#galastwebcampaign_il').val();
                obj.LastWebMedium = $('#galastwebmedium_il').val();
                obj.LastWebSource = $('#galastwebsource_il').val();
                obj.WebCampaignStack = $('#gawebcampaignstack_il').val();
                obj.WebLeadId = $('#gawebleadid_il').val();

                // Co-owner/Co-buyer
                obj.CoBuyerFirstName = $('#coOwnerFirstName').val();
                obj.CoBuyerLastName = $('#coOwnerLastName').val();

                // Co-buyer first name and last name both should be empty
                // Or, both shoud have values 
                var coBuyerIsValid = ((obj.CoBuyerFirstName === "" && obj.CoBuyerLastName === "")
                || (obj.CoBuyerFirstName !== "" && obj.CoBuyerLastName !== ""));

                // If the validation passes, send the ajax call
                if (coBuyerIsValid && IsPhoneAndCheckboxValid) 
                {
                    const dataJSON = JSON.stringify(obj);
                    $.ajax({
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        method: "POST",
                        url: "/myaccount/postdata/",
                        data: dataJSON,
                        success: function (response) {
                            // On Success reveal the success msg
                            if (response.Success) {
                                $("#successMsg").removeClass("hide");
                            } else {
                                $("#failMsg").removeClass("hide");
                            }
                        },
                        error: function (response) {
                            $("#failMsg").removeClass("hide");
                        },
                        complete: function()
                        {
                            window.hidePreLoader();
                        }
                    });
                } else 
                { 
                    $("#successMsg").addClass("hide"); 
                    window.hidePreLoader();
                }
            }else{window.hidePreLoader();}
        });
    }
};
function triggerFieldValidation(idInput,idErrorMsg)
{
    if(!$(idInput)[0].validity.valid)
    {
        $(idErrorMsg).addClass('is-visible');
        $(idInput).addClass('is-invalid-input'); 
    }else{
        $(idErrorMsg).removeClass('is-visible');
        $(idInput).removeClass('is-invalid-input'); 
    }
}
$(function(){
    // Attach listener on lot dropdown
    let ownerForm = $("#owner-account-form");
    if( ownerForm && ownerForm.length > 0 ) {
        contactInfoOwner.initContactInfoOwner();
    }
});

export default contactInfoOwner;